import { useState, useEffect } from "react";

/**
 * SelectBox
 * @param {number} title 기본 값
 * @param {string} options SelectBox 값
 */
export default function SelectBox({ title, options, dataValue }) {
    
    // selected 기본
    const [selectedOption, setSelectedOption] = useState(title);
    // selected 숨김 여부
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    // 성함 혹은 회사명 선택 여부
    const [selectBoxClick, setselectBoxClick] = useState(false);

    /// selected 숨김 여부 함수
    const handleSelectClick = () => {
      setIsDropdownOpen(!isDropdownOpen);
      if (selectedOption === '선택' && isDropdownOpen) {
        setselectBoxClick(true)
      }
    };

    ///selected 숨김 여부 및 선택
    const handleOptionClick = (option) => {
        setSelectedOption(option);
        dataValue['menu'] = option
        setselectBoxClick(false)
    };

    useEffect(() => {
    // select 클릭 외에 숨김
      const handleClickOutside = (event) => {
        const selectElement = document.querySelector('#select');
        if (selectElement) {
          if (!event.target.matches("#select")) {
            setIsDropdownOpen(false);
            if (document.querySelector('#select').innerText === '선택' && isDropdownOpen) {
              setselectBoxClick(true)
            }
          }
        }

    };

    document.addEventListener("click", handleClickOutside);
  });
    
  return (
    <div className="select-wrap">
        <div id="select" className="select" onClick={handleSelectClick}>{selectedOption}</div>
        {isDropdownOpen && (
          <ul id="ul" className="select-ul">
              {options.map((option) => (
              <li key={option.value} value={option.value} onClick={() => handleOptionClick(option.name)}>{option.name}</li>      
              ))}
          </ul>
      )}
      { selectBoxClick && <div className="invalid-feedback">메뉴를 선택 해주세요</div> }
    </div>
  )
}